import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import React from "react";
import { useDeviceInfoQuery } from "@/hooks";
import styles from "@/styles/Video.module.scss";
import AppStoreBadge from "../../../svgs/App_Store_Badge_JP.svg";

export default function IOSAppDownloadBanner() {
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });
  const isIOS = maybeIOS(deviceInfo);

  if (!isIOS) return null;
  return (
    <a href={config.appStoreUrl.ios}>
      <AppStoreBadge className={styles["getin-itunes"]}></AppStoreBadge>
    </a>
  );
}
